import { confirmNavigationAtom } from '../atoms/confirmNavigationAtom';
import { modals } from '@mantine/modals';
import { useAtom } from 'jotai';
import { ulid } from 'ulid';
import { type BaseLocationHook } from 'wouter';
import { useBrowserLocation } from 'wouter/use-browser-location';

export const useLocationWithConfirmation: BaseLocationHook = () => {
  const [location, navigate] = useBrowserLocation();
  const [shouldConfirm, setShoulcConfirm] = useAtom(confirmNavigationAtom);
  const modalId = ulid();
  return [
    location,
    (newLocation) => {
      if (shouldConfirm) {
        modals.openConfirmModal({
          children: (
            <div>
              There are aunsaved changes. They will be lost if you proceed.
            </div>
          ),
          confirmProps: {
            color: 'red',
          },
          labels: { cancel: 'Cancel', confirm: 'Proceed' },
          modalId,
          onCancel: () => modals.close(modalId),
          onConfirm: () => {
            setShoulcConfirm(false);
            navigate(newLocation);
          },
          title: <strong>Are you sure?</strong>,
        });
      } else {
        navigate(newLocation);
      }
    },
  ];
};
